import styled from 'styled-components';

import { grey6, grey7 } from 'approot/shared/styles/colours.style';
import { Box } from 'approot/shared/design-system/box/box.style';

export const ClassroomAwaiting = styled(Box)`
  color: ${grey7};
  margin: auto;
  svg path {
    fill: ${grey6};
  }
`;
